import { isEmpty } from "@swiggy-private/js-utils";
import {
    BOOLEAN_AS_STRING,
    CART_JOURNEY_ADDITIONAL_CONTEXT_KEYS,
    ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS,
    OnPremiseFulfilmentData,
    ReviewedCartApiResponse,
} from "@swiggy-private/cart-types";

export function getOnPremiseFulfilmentData(
    reviewedCartResponse?: ReviewedCartApiResponse | null,
): OnPremiseFulfilmentData | undefined {
    return reviewedCartResponse?.on_premise_fulfilment_data ?? undefined;
}

export const isOnPremiseFulfilmentCart = (reviewedCartResponse?: ReviewedCartApiResponse | null): boolean => {
    const onPremiseData = getOnPremiseFulfilmentData(reviewedCartResponse);
    return !isEmpty(onPremiseData) && onPremiseData?.is_on_premise_fulfilment_order === BOOLEAN_AS_STRING.TRUE;
};

export function getOnPremiseCartJourneyAdditionalContext(
    cartData?: ReviewedCartApiResponse,
): Record<string, string> | undefined {
    const onPremiseData = getOnPremiseFulfilmentData(cartData);
    if (!onPremiseData) {
        return undefined;
    }

    return {
        [CART_JOURNEY_ADDITIONAL_CONTEXT_KEYS.ON_PREMISE_FULFILMENT]: JSON.stringify({
            [ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS.IS_ON_PREMISE_FULFILMENT_ORDER]:
                onPremiseData.is_on_premise_fulfilment_order,
            [ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS.ORDER_PREFERENCE]: onPremiseData.order_preference,
            [ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS.AUDI_NUMBER]: onPremiseData.audi_number,
            [ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS.SEAT_NUMBER]: onPremiseData.seat_number,
            [ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS.MOBILE_NUMBER]: onPremiseData.mobile_number,
        }),
    };
}
